import router from './router';
import { getToken } from '@/utils/auth';

const BASE_TITLE = '杭州图景网络技术有限公司';

router.beforeEach((to, from, next) => {
  const hasToken = !!getToken();

  // 已登录时不再进入登录页
  if (to.path === '/login' && hasToken) {
    next({ path: (to.query && to.query.redirect) || '/' });
    return;
  }

  // 需要登录才能访问的页面，在路由 meta 上标记 requiresAuth: true
  if (to.meta && to.meta.requiresAuth && !hasToken) {
    next({ path: '/login', query: { redirect: to.fullPath } });
    return;
  }

  next();
});

router.afterEach(to => {
  const title = to.meta && to.meta.title;
  document.title = title ? title + ' - ' + BASE_TITLE : BASE_TITLE;
});
